import type { CSSProperties } from 'react';
import type { WatermarkAnchor } from './campaign-watermark-types';

/**
 * Returns CSS positioning props for a watermark image inside a
 * `position: relative` parent. Coords are percent strings.
 *
 * The image should additionally be `position: absolute` and have a
 * height set as a % of the parent.
 */
export const getAnchorStyle = (
  anchor: WatermarkAnchor,
  marginXPercent: number,
  marginYPercent: number,
): CSSProperties => {
  const mx = `${marginXPercent || 0}%`;
  const my = `${marginYPercent || 0}%`;

  switch (anchor) {
    case 'top-left':
      return { top: my, left: mx };
    case 'top-right':
      return { top: my, right: mx };
    case 'bottom-left':
      return { bottom: my, left: mx };
    case 'bottom-right':
      return { bottom: my, right: mx };
    case 'top-center':
      return { top: my, left: '50%', transform: 'translateX(-50%)' };
    case 'bottom-center':
      return { bottom: my, left: '50%', transform: 'translateX(-50%)' };
    case 'center-left':
      return { left: mx, top: '50%', transform: 'translateY(-50%)' };
    case 'center-right':
      return { right: mx, top: '50%', transform: 'translateY(-50%)' };
    case 'center':
      return { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };
    default:
      return { bottom: my, left: '50%', transform: 'translateX(-50%)' };
  }
};
